import { render, staticRenderFns } from "./Terminanmeldungen.vue?vue&type=template&id=6d2f562c&scoped=true"
import script from "./Terminanmeldungen.vue?vue&type=script&lang=ts"
export * from "./Terminanmeldungen.vue?vue&type=script&lang=ts"
import style0 from "./Terminanmeldungen.vue?vue&type=style&index=0&id=6d2f562c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.22_cache-loader@4.1.0_webpack@4.47.0__css-load_03226246ddea4f5c1fed9b2f163fa79a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2f562c",
  null
  
)

export default component.exports